exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sc-suggestions-row {\r\n  text-align: center;\r\n  background: inherit;\n}\n.sc-suggestions-element {\r\n  margin: 3px;\r\n  padding: 5px 10px 5px 10px;\r\n  border: 1px solid;\r\n  border-radius: 15px;\r\n  font-size: 14px;\r\n  background: inherit;\r\n  cursor: pointer;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11adff40","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/vue-beautiful-chat/src/Suggestions.vue
// module id = 1991
// module chunks = 120